import React, { useCallback , useContext } from 'react';
import { connect } from 'react-redux';
import ThemeContext from '../../../store/theme-context';
import classes from './SideDrawer.module.css';
import Backdrop from '../../UI/Backdrop/Backdrop';
import NavigationItems from '../NavigationItems/NavigationItems';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import styled from 'styled-components';
import { withRouter } from "react-router";


const ModeIcon = styled.div`
    position: absolute;
    bottom:30px;
    left: 15px;
`
const CartIcon = styled.div`
    position: absolute;
    bottom:30px;
    right: 30px;
    display:flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    color: #fff;
    background-color: #000
`
const CartIconLabel = styled.span`
    display:flex;
    align-items: center;
    justify-content: center;
    width           : 26px;
    height          : 26px;
    border-radius   : 50%;
    background-color: #e01a1a;
    color           : #fff;
    font-size       : 11px;
    font-weight     : 500;
    text-align      : center;
    position        : absolute;
    top             : -3px;
    left            : 38px;
    `


const SideDrawer = ( props ) => {
    let attachedClasses = [];
    props.opened ? attachedClasses = classes.Open : attachedClasses = classes.Close
    
    const { history , event: closeSideDrawer, cartQuantity } = props ;

    const themeCtx = useContext(ThemeContext);

    const cartRedirectHandler = useCallback( ( ) => {
        history.push('/cart');
    }, [ history ])

    return (
        <React.Fragment>
            <Backdrop show={props.opened} remove={closeSideDrawer} />
            <div className={ [ classes.SideDrawer , attachedClasses ].join(' ') } >
                <div className={classes.Logo}> 
                    colorfy
                </div>
                <nav onClick={closeSideDrawer}>
                    <NavigationItems isAuth={props.authentication} />
                </nav>
                <CartIcon onClick= {cartRedirectHandler}>
                    <ShoppingCartOutlinedIcon />
                    <CartIconLabel>{cartQuantity ? cartQuantity : 0 }</CartIconLabel>
                </CartIcon>
                <ModeIcon>
                    <IconButton sx={{ color: themeCtx.theme.palette.background.default }} onClick={themeCtx.toggleMode} >
                        {themeCtx.theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                    </IconButton>
                </ModeIcon>
            </div>

        </React.Fragment>
    );    
};
const mapStateToProps = state =>{
    return {
        cartQuantity: state.cart.cartQuantity,
    }
}


export default connect( mapStateToProps , null )(withRouter(SideDrawer));